var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 3C22 2.44772 21.5523 2 21 2H17H9H8.41421C8.149 2 7.89464 2.10536 7.70711 2.29289L2.29289 7.70711C2.10536 7.89464 2 8.149 2 8.41421V21C2 21.5523 2.44772 22 3 22H6H18H21C21.5523 22 22 21.5523 22 21V3ZM8 4.828L4 8.828V20H5V13C5 12.4477 5.44772 12 6 12H18C18.5523 12 19 12.4477 19 13V20H20V4H18V8C18 8.55228 17.5523 9 17 9H9C8.44772 9 8 8.55228 8 8V4.828ZM16 4H10V7H16V4ZM17 20H7V14H17V20Z",
    fill: "#979797"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 3C22 2.44772 21.5523 2 21 2H17H9H8.41421C8.149 2 7.89464 2.10536 7.70711 2.29289L2.29289 7.70711C2.10536 7.89464 2 8.149 2 8.41421V21C2 21.5523 2.44772 22 3 22H6H18H21C21.5523 22 22 21.5523 22 21V3ZM8 4.828L4 8.828V20H5V13C5 12.4477 5.44772 12 6 12H18C18.5523 12 19 12.4477 19 13V20H20V4H18V8C18 8.55228 17.5523 9 17 9H9C8.44772 9 8 8.55228 8 8V4.828ZM16 4H10V7H16V4ZM17 20H7V14H17V20Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.8792feb18adecf14f229b305f3d56155.svg";
export { ForwardRef as ReactComponent };